// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signup } from '../../actions/session'
import AuthBackground from '../../components/AuthBackground'
import SignupForm from './components/SignupForm'

type Props = {
  errors: Object,
  signup: Function
}

class Signup extends Component {
  props: Props

  handleSubmit = (data) => this.props.signup(data)

  render() {
    return (
      <AuthBackground>
        <SignupForm onSubmit={this.handleSubmit} errors={this.props.errors} />
      </AuthBackground>
    )
  }
}

export default connect(
  (state) => ({
    errors: state.session.signupErrors
  }),
  { signup }
)(Signup)



// WEBPACK FOOTER //
// ./src/views/Signup/index.js